// extracted by mini-css-extract-plugin
export default {"redText":"TrajectoryCheck_redText__iG4jL","yellowText":"TrajectoryCheck_yellowText__L95LL","greenText":"TrajectoryCheck_greenText__SUzD2","title":"TrajectoryCheck_title__wygeC"};